import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { NakedForm, SwitchField } from '@/components';
import { features } from '@/config/features';
import { useFeatures } from '@/contexts';

const FeaturesForm = () => {
  const {
    isFeatureEnabled,
    enableFeature,
    disableFeature,
    features: storedFeatures,
  } = useFeatures();

  const defaultValues = features.reduce(
    (acc, feature) => {
      acc[feature.name] =
        storedFeatures[feature.name] !== undefined
          ? isFeatureEnabled(feature.name)
          : (feature.defaultEnabled ?? false);

      return acc;
    },
    {} as Record<string, boolean>,
  );

  const methods = useForm({ defaultValues });
  const allValues = methods.watch();

  useEffect(() => {
    features.forEach(({ name }) => {
      const enabled = allValues[name];
      const contextEnabled = isFeatureEnabled(name);

      if (enabled === contextEnabled) {
        return;
      }

      if (enabled) {
        return enableFeature(name);
      }

      return disableFeature(name);
    });
  }, [allValues, isFeatureEnabled, enableFeature, disableFeature]);

  return (
    <div className="flex flex-col gap-2">
      {features.length > 0 && (
        <h3 className="text-black dark:text-white">Features</h3>
      )}
      <NakedForm methods={methods} onSubmit={() => {}} className="grid gap-2">
        {features.map((feature) => (
          <SwitchField
            key={feature.name}
            name={feature.name}
            title={feature.title}
            allowUndefinedState={false}
            className="text-sm text-gray-500 dark:text-gray-400 font-semibold"
          />
        ))}
      </NakedForm>
    </div>
  );
};

export default FeaturesForm;
